import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminRejectImageMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ imageId: e, reason: t }) => r.rejectImage(e, t ? { reason: t } : void 0),
		onSuccess: (t, { listingId: n }) => {
			i.invalidateQueries({ queryKey: ["admin-listings", "moderation"] }), n && i.invalidateQueries({ queryKey: e.images(n) });
		}
	});
};
//#endregion
export { i as useAdminRejectImageMutation };
